import { providers, Signer } from "ethers"

import Contract from "./Contract"
import { RewardFarmerABI } from "../../../artifacts/polygon/abi"

export enum Character {
	HONEST_FARMER,
	FARM_GIRL,
	ANIMAL,
	LAND,
	HONORARY,
}

export enum RewardType {
	TAX,
	STAKING,
	AIRDROP,
	HONEST_WORK,
	TREASURY,
	LP_FARMING,
}

class RewardFarmer extends Contract {
	constructor(
		address: string,
		signerOrProvider: Signer | providers.Provider,
	) {
		super(address, RewardFarmerABI, signerOrProvider)
	}

	async claimStakingReward(character: Character, characterId: number) {
		return this.callFunction<[typeof character, typeof characterId]>(
			"claimStakingReward",
			character,
			characterId,
		)
	}

	async claimStakingRewardBatch(
		character: Character,
		characterIds: number[],
	) {
		return this.callFunction<[typeof character, typeof characterIds]>(
			"claimStakingRewardBatch",
			character,
			characterIds,
		)
	}

	async claimCharacterAirdrop(character: Character, characterId: number) {
		return this.callFunction<[typeof character, typeof characterId]>(
			"claimCharacterAirdrop",
			character,
			characterId,
		)
	}

	async claimCharacterAirdropBatch(
		character: Character,
		characterIds: number[],
	) {
		return this.callFunction<[typeof character, typeof characterIds]>(
			"claimCharacterAirdropBatch",
			character,
			characterIds,
		)
	}

	// Views
	async getRewardableBlocks(character: Character, characterId: number) {
		return this.callFunction<[typeof character, typeof characterId]>(
			"getRewardableBlocks",
			character,
			characterId,
		)
	}

	async getAirdropAllocation(account: string) {
		return this.callFunction<[typeof account]>(
			"getAirdropAllocation",
			account,
		)
	}

	async getAirdropAllocationBatch(accounts: string[]) {
		return this.callFunction<[typeof accounts]>(
			"getAirdropAllocationBatch",
			accounts,
		)
	}

	async getCharacterAirdropAllocation(
		character: Character,
		characterId: number,
	) {
		return this.callFunction<[typeof character, typeof characterId]>(
			"getCharacterAirdropAllocation",
			character,
			characterId,
		)
	}

	async getCharacterAirdropAllocationBatch(
		character: Character,
		characterIds: number[],
	) {
		return this.callFunction<[typeof character, typeof characterIds]>(
			"getCharacterAirdropAllocationBatch",
			character,
			characterIds,
		)
	}

	async claimAirdrop() {
		return this.callFunction("claimAirdrop")
	}
}

export default RewardFarmer
